type SQLiteTablesType = {
    version: 'version',
    prayers: 'prayers', 
    prayerSettings: 'prayerSettings', 
    readingPlanRecords: 'readingPlanRecords',
    dismissibleMessages: 'dismissibleMessages',
    bibleSettings: 'bibleSettings',
    fellowshipSettings: 'fellowshipSettings',
    fellowshipPosts: 'fellowshipPosts',
}
export const SQLiteTables: SQLiteTablesType = {
    version: 'version',
    prayers: 'prayers', 
    prayerSettings: 'prayerSettings', 
    readingPlanRecords: 'readingPlanRecords',
    dismissibleMessages: 'dismissibleMessages',
    bibleSettings: 'bibleSettings',
    fellowshipSettings: 'fellowshipSettings',
    fellowshipPosts: 'fellowshipPosts',
}

export type SQLiteTablesValues = typeof SQLiteTables[keyof typeof SQLiteTables];